/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import AgGrid from 'DesignSystem/AgGrid/react'
import Chart from './Chart/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/Report/ReportTable/Done/Content",
  sideBar,
  statusBar,
  totalColumns,
  columnsVisible,
  filterModel,
  isExternalFilterPresent,
  doesExternalFilterPass,
  onSelectionChanged,
  onToggleColumnsVisibility,
  rowGroupPanelShow,
  rowSelection,
  onIsRowSelected,
  tablePreset
  
}) {
let reportTableColumnsValueData = fromData.useDataValue({ viewPath,
context: 'report_table',
path: 'columns',
})
let reportTableDataValueData = fromData.useDataValue({ viewPath,
context: 'report_table',
path: 'data',
})
let reportTablePresetDataValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'table_preset.data',
})
let reportGridOptionsValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'grid_options',
})
let onChangeTablePreset = fromHelpers.useOnChangeTablePreset({
  children,
  viewPath,
  sideBar,
  statusBar,
  totalColumns,
  columnsVisible,
  filterModel,
  isExternalFilterPresent,
  doesExternalFilterPass,
  onSelectionChanged,
  onToggleColumnsVisibility,
  rowGroupPanelShow,
  rowSelection,
  onIsRowSelected,
  tablePreset
  
})
  return (<React.Fragment
>
<AgGrid
  viewPath={`${viewPath}/AgGrid`}
 height="100%"
 data="report_table.columns"
 columnDefs={reportTableColumnsValueData}
 data="report_table.data"
 rowData={reportTableDataValueData}
 data="report.table_preset.data"
 tablePreset={reportTablePresetDataValueData}
 sideBar={sideBar}
 statusBar={statusBar}
 groupIncludeTotalFooter={true}
 totalColumns={totalColumns}
 columnsVisible={columnsVisible}
 filterModel={filterModel}
 isExternalFilterPresent={isExternalFilterPresent}
 doesExternalFilterPass={doesExternalFilterPass}
 onSelectionChanged={onSelectionChanged}
 onToggleColumnsVisibility={onToggleColumnsVisibility}
 rowGroupPanelShow={rowGroupPanelShow}
 rowSelection={rowSelection}
 onIsRowSelected={onIsRowSelected}
 tablePreset={tablePreset}
 onChangeTablePreset={onChangeTablePreset}
 data="report.grid_options"
 gridOptions={reportGridOptionsValueData}
/>
<Chart
  viewPath={`${viewPath}/Chart`}
/>
{children}
</React.Fragment>)
}